// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require("admin-lte")
import toastr from 'toastr'
require("@fortawesome/fontawesome-free/css/all")
require("bootstrap")
require("bootstrap-notify")
require("slim-select")
require("../src/application.scss")
require("turbolinks").start()

// initialize toastr
toastr.options.timeOut = 2000
window.toastr = toastr


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

$(document).on('turbolinks:load', function () {

  // AdminLTEの表示崩れ抑制
  // $.AdminLTE.layout.fix();
  //$('body').layout('fix');

  // sidebar-menuが壊れている問題の対策
  // https://github.com/almasaeed2010/AdminLTE/issues/1666#issuecomment-376085130
  //$('.sidebar-menu').tree();

  $.notifyDefaults({ delay: 2000, z_index: 99999 });

  if ($('#flash_success_message').length) {
    $.notify({ icon: 'fa fa-check', message: $('#flash_success_message').val() },{ type: 'success' });
  }
  if ($('#flash_info_message').length) {
    $.notify({ icon: 'fa fa-info', message: $('#flash_info_message').val() },{ type: 'info' });
  }
  if ($('#flash_warning_message').length) {
    $.notify({ icon: 'fa fa-warning', message: $('#flash_warning_message').val() },{ type: 'warning' });
  }
  if ($('#flash_danger_message').length) {
    $.notify({ icon: 'fa fa-ban', message: $('#flash_danger_message').val() },{ type: 'danger' });
  }

  // ヘルプなどで使うtooltip
  // bootstrapのTooltipsを使用する。
  // tooltip外をクリックしたら閉じるようにする。
  $('[data-toggle="tooltip"]').tooltip();
  $('body').on('click', function(e) {
    $('[data-toggle="tooltip"]').tooltip('hide');
  });
  $('body').on('click', '.tooltip-inner', function(e) {
    e.stopPropagation();
  });
  $('[data-toggle="tooltip"]').on('click', function(e) {
    var self = this;
    $('[data-toggle="tooltip"]').each(function(i, v) {
      if (v == self) return;
      $(v).tooltip('hide');
    });
    e.stopPropagation();
  });

  // select値がキャッシュされてしまう問題に対応
  $("select").each((i, select) => {
    for (const option of select.selectedOptions) {
      option.selected = option.selected;
    }
  });
});

$(document).on('turbolinks:before-cache', function() {

  //戻るボタンのときはnotifyは表示されないようにする
  $('div[data-notify="container"]').remove();
  $('input.notify-float-data').remove();
});